import { apiProductAnnouncements } from "@/api/product-announcement.api.ts";
import { ApiErrorException } from "@/types/api.types.ts";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useQuery } from "@tanstack/react-query";

export const productAnnouncementsKeys = createQueryKeys("product-announcements", {
  current: {
    queryKey: null,
    queryFn: async ({ signal }) => {
      const result = await apiProductAnnouncements.getCurrent(signal);
      if (result.error) throw new ApiErrorException(result.error);
      return result.data ?? null;
    },
  },
});

export const useCurrentProductAnnouncement = () => {
  return useQuery({
    ...productAnnouncementsKeys.current,
  });
};
